// src/components/ui/calendar/core/CalendarGrid/CalendarGrid.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const CalendarGrid = ({
  type = 'week', // 'week', 'month', 'day', 'custom'
  children,
  className = '',
  showBorders = true,
  responsive = true
}) => {
  // Grid type configurations
  const gridConfig = {
    week: {
      container: 'grid grid-cols-7',
      borders: 'gap-0'
    },
    month: {
      container: 'grid grid-cols-7',
      borders: 'gap-0'
    },
    day: {
      container: 'flex flex-col',
      borders: ''
    },
    custom: {
      container: '',
      borders: ''
    }
  };

  const config = gridConfig[type];

  // Border styles (matching your current implementation)
  const borderStyles = showBorders ? {
    week: 'border-b border-slate-600/20',
    month: 'border-r border-b border-slate-600/30 last:border-r-0',
    day: 'border-b border-slate-600/20'
  } : {};

  return (
    <div className={cn(
      // Base grid layout
      config.container,
      config.borders,
      
      // Responsive behavior
      responsive && type === 'week' && 'lg:grid-cols-7 sm:grid-cols-1',
      responsive && type === 'month' && 'lg:grid-cols-7 sm:grid-cols-1',
      
      className
    )}>
      {React.Children.map(children, (child, index) => {
        if (!child) return null;
        
        // Apply border styles to children if needed
        if (showBorders && borderStyles[type]) {
          return React.cloneElement(child, {
            className: cn(
              child.props.className,
              borderStyles[type]
            )
          });
        }
        
        return child;
      })}
    </div>
  );
};

export default CalendarGrid;